import axios from 'axios';
import store from '@/store';
import { typesApp } from '@/store/app/typesModuleApp';

const setPosting = (isPosting) => {
  store.dispatch(`${typesApp.PATH}/${typesApp.actions.UPDATE_IS_POSTING}`, isPosting);
};

export const emailAxios = async (config) => {
  const { isPosting, headers } = config;

  setPosting(isPosting); // show loading

  const { data } = await axios({
    ...config,
    headers: { ...headers },
  });

  if (isPosting) setPosting(false); // hide loading

  return data;
};

export default {};
